export const drawPlotsArticle = {
    id: 'draw-plots',
    title: 'Участки',
    category: 'Режим рисования',
    requiredModule: null,
    sandboxType: null,
    summary: 'Земельные участки: сетка сценариев, авторасчет площади в сотках, таблица статусов со «светофором» и категории.',
    markdown: `
> **Инструмент «Участки»** — это фундамент вашей карты. Любая работа начинается с земли: сначала очерчиваются границы участков, а уже внутри них «вырастают» дома, прокладываются дороги и ставятся фонари.

---

## 1. Что можно отмечать этим инструментом

Инструмент создаёт замкнутые контуры любой формы. Вот 4 частых сценария:

:::grid cols=2
:::card icon="home" title="1. Частные участки на продажу"
Нарезка участков для покупателей: с номерами, границами, стоимостью, контактами собственников или бейджем «В продаже».
:::

:::card icon="trees" title="2. Общие зоны и парки"
Территории посёлка для всех жителей: скверы, детские городки, пляжи, спортивные площадки и гостевые парковки.
:::

:::card icon="layers" title="3. Будущие очереди стройки"
Большие контуры полей или кварталов, которые планируется осваивать через год или два (для общего генплана развития).
:::

:::card icon="shield-alert" title="4. Охранные и санитарные зоны"
Зоны с ограничениями: водоохранная полоса у озера, полоса отвода ЛЭП или газовой трубы, где нельзя строить капитальные дома.
:::
:::

---

## 2. Автоматический расчёт площади: сотки без калькулятора

Вам больше не нужно считать площадь по сложным формулам или переводить метры в сотки на бумажке:

:::tip Умный калькулятор прямо на карте
* **Считает мгновенно:** как только вы замкнули контур участка (нажав \`Enter\` или кликнув повторно по последней точке), система сразу рассчитывает точный размер в **квадратных метрах (м²)** и привычных **сотках** (а для больших полей — в гектарах).
* **Сразу в паспорте:** при создании нового участка рассчитанная площадь автоматически подставляется в карточку объекта. Если вы вручную скорректировали площадь по официальным документам ЕГРН, система бережно сохранит ваше значение.
:::

---

## 3. Статусы участка: продаётся или в резерве?

Чтобы покупатели на публичной карте сразу видели доступные лоты, в паспорте участка есть переключатели готовности:

| Статус | Как выглядит | Что означает |
| :--- | :---: | :--- |
| **В продаже** | 🟢 Зелёный бейдж | Участок свободен, проверен и выставлен на продажу. Покупатели видят его в поиске и на витрине. |
| **Запланировано** | 🟡 Жёлтый бейдж | Участок в резерве или относится к будущей очереди. Показывает масштаб посёлка, но пока не продаётся. |
| **На учёте** | ⚪ Без отметки | Базовый статус: внутренний учёт территории, технические зоны или участки общего пользования. |

:::info Почему у земли нет статуса «В строительстве»?
Участки не имеют статуса стройки, потому что сама земля строиться не может. Строятся конкретные объекты — коттеджи, таунхаусы или дороги.  
Их наносят поверх участка отдельными инструментами (**«Здания»** или **«Линии»**), и именно у них включается статус \`🏗️ Строится\`.
:::

---

## 4. Категории и цвета: порядок на генплане

Чтобы карта не превращалась в однотонное полотно, каждому участку в паспорте назначается **Категория** (например, *«ИЖС»*, *«Парк»*, *«Коммерция»*):

* Вы выбираете категорию из выпадающего списка — и участок **автоматически окрашивается в нужный цвет** согласно легенде проекта.
* Если нужно показать особый статус (например, сервитут или временный запрет на стройку), участку можно задать аккуратную диагональную штриховку.
`
};
